import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonBase} from "@/shared/ui/buttons/button-base";
import {assetPath} from "@/shared/utils/asset-path";

interface PopularPostsLoadMoreProps {
    hasMore: boolean;
    onLoadMore?: () => void;
    isButtonLoading: boolean;
    showMoreText: string;
}

export function PopularPostsLoadMore({hasMore, onLoadMore, isButtonLoading, showMoreText}: PopularPostsLoadMoreProps): JSX.Element | null {
    if (!hasMore || !onLoadMore) return null;

    return (
        <div className="popular-posts__button-wrap">
            <ButtonBase as="button" variant="secondary-outline" size="sm" width="auto" onClick={onLoadMore} loading={isButtonLoading}>
                {showMoreText}
                {!isButtonLoading && (
                    <SmartImage src={assetPath("/images/icons/arrow-black-down.svg")} alt="Arrow" width={12} height={10} style={{marginLeft: 8}} />
                )}
            </ButtonBase>
        </div>
    );
}
